<template>
  <div class="deposit-container">
    <div class="cardgroup">
      <div class="channels">
        <div @click="changType(0)" :class="type == 0 ? 'channel active' : 'channel'">
          <div class="title">虚拟币取款</div>
          <div class="border"></div>
        </div>
        <div @click="changType(1)" :class="type == 1 ? 'channel active' : 'channel'">
          <div class="title">人民币取款</div>
          <div class="border"></div>
        </div>
      </div>
    </div>
    
    <!-- 虚拟币取款 -->
    <div class="deposit" v-if="type == 0">
      <div class="low-special">
        <div class="deposit-title">提现到</div>

        <div class="address-list">
          <div 
            @click="changBankId(item.id)" 
            v-for="(item, index) in usdssLis" 
            :key="index" 
            :class="bankId == item.id ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'"
          >
            <div class="deposit-item active">
              <div class="deposit-info">
                <img class="icon" src="/static/image/usdt.png" alt="USDT图标" />
                <span>
                  {{ item.bank_owner }}<br />
                  <span class="subText"> {{ item.bank_no }}</span>
                </span>
              </div>
            </div>
          </div>
          
          <div class="deposit-bq noBorder" @click="openUsdt" v-if="usdssLis.length < 6">
            <div class="deposit-item active">
              <div class="deposit-info">
                <img class="icon" src="data:image/png;base64,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" 
                     alt="添加图标" />
                <span>
                  添加取款方式<br />
                  <span class="subText">添加USDT地址</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="deposit-title">金额</div>
        <div class="amount-wrap">
          <input placeholder="请输入转账金额" v-model="amount" type="text" maxlength="17" class="amount-input" />
          <div class="amount-unit">CNY</div>
        </div>
        
        <div class="deposit-title">支付密码</div>
        <div class="amount-wrap">
          <input placeholder="请输入支付密码" v-model="password" type="password" maxlength="17" class="amount-input" />
        </div>
        
        <div class="deposit-title" v-if="chanmeyXi">
          手续费
          <span style="font-size:12px;color:#999">
            {{ chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee : $store.state.userInfo.withdrawfeeusdttrc }}
          </span>
        </div>

        <div class="deposit-title">
          USDT换算: &nbsp;&nbsp;&nbsp;&nbsp;
          <span style="font-size:12px;color:#999">
            {{ amount ? Math.floor((amount / currentRate) * 100) / 100 : '0.00' }}
            &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;参考汇率：{{ currentRate.toFixed(2) }}
            <span v-if="isRefreshing" class="refreshing-icon">⟳</span>
            <span v-if="rateError" style="color: #ff4d4f; margin-left: 5px;">获取失败</span>
          </span>
        </div>

        <div class="deposit-title">
          实际到账：&nbsp;&nbsp;&nbsp;&nbsp;
          <span style="font-size:12px;color:#999">
            {{ amount ? Math.floor((amount / currentRate) * 100) / 100 - (chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee * 1 : $store.state.userInfo.withdrawfeeusdttrc * 1) : '0.00' }}
          </span>
        </div>

        <div class="wxsm-tips">
          <i></i>
          <div>温馨提示：如有疑问请联系客服 <span @click="$parent.openKefu()">联系客服</span></div>
        </div>
        
        <div class="low-special-btn" @click="withdraw">确定</div>
        <div style="height: 88px"></div>
      </div>
      
      <!-- 添加USDT地址弹窗 -->
      <div class="dialog" v-if="showUsdt">
        <div class="dialog-cover back" @click="openUsdt"></div>
        <div class="dialog-content">
          <div class="side">
            <div class="side__header">
              <span>添加USDT地址</span>
              <a href="javascript:void 0;" class="side__close" @click="openUsdt"></a>
            </div>
            <div class="side__content">
              <div class="gold">
                <img src="/static/image/usdt.png" alt="USDT图标" class="gold__img" />
                
                <div class="form-group">
                  <label class="form-label">USDT地址</label>
                  <input type="text" v-model="usdss" class="form-control" placeholder="请输入USDT地址" />
                </div>
                
                <div class="form-group">
                  <label class="form-label">钱包协议</label>
                  <div class="protocol-selector">
					<span @click="changmeyXi('TRC20')" :class="meyXi == 'TRC20' ? 'protocol-item active' : 'protocol-item'">TRC20</span>  
                    <span @click="changmeyXi('ERC20')" :class="meyXi == 'ERC20' ? 'protocol-item active' : 'protocol-item'">ERC20</span>
                  </div>
                </div>
                
                <div class="form-group">
                  <label class="form-label">支付密码</label>
                  <input v-model="pay_pass" type="password" class="form-control" placeholder="请输入支付密码" />
                </div>

                <button class="scan__button" @click="bindUsdss">确认添加</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 人民币取款部分 -->
    <div class="deposit" v-if="type == 1">
      <div class="low-special">
        <div class="deposit-title">提现到</div>

        <div>
          <div>
            <div @click="changBankId(item.id)" v-for="(item, index) in cardLis" :key="index" 
                 :class="bankId == item.id ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'">
              <div class="deposit-item active">
                <div class="deposit-info">
                  <img class="icon" :src="item.ico" alt="银行卡图标" />
                  <span>
                    {{ item.bank }}---{{ item.bank_owner }}<br />
                    <span class="subText"> {{ item.bank_no }}</span>
                  </span>
                </div>
              </div>
            </div>
            
            <div class="deposit-bq noBorder" @click="$parent.goNav('/addBankCard')" v-if="cardLis.length < 6">
              <div class="deposit-item active">
                <div class="deposit-info">
                  <img class="icon" src="data:image/png;base64,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" 
                       alt="添加图标" />
                  <span>
                    添加取款方式<br />
                    <span class="subText">添加银行卡</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="deposit-title">金额</div>
          <div class="amount-wrap">
            <input placeholder="请输入转账金额" v-model="amount" type="text" maxlength="17" class="amount-input" />
            <div class="amount-unit">CNY</div>
          </div>
        </div>
        
        <div class="deposit-title">支付密码</div>
        <div class="amount-wrap">
          <input placeholder="请输入支付密码" v-model="password" type="password" maxlength="17" class="amount-input" />
        </div>
        
        <div class="wxsm-tips">
          <i></i>
          <div>温馨提示：如有疑问请联系客服 <span @click="$parent.openKefu()">联系客服</span></div>
        </div>
        
        <div class="low-special-btn" @click="withdraw">确定</div>
        <div style="height: 88px"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Withdrawal',
  data() {
    return {
      type: 0,
      cardLis: [],
      usdssLis: [],
      amount: null,
      password: null,
      bankId: null,
      showUsdt: false,
      pay_pass: null,
      usdss: null,
      meyXi: 'TRC20',
      chanmeyXi: null,
      baseURL: '',
      // 汇率相关数据
      currentRate: 7.00, // 默认汇率
      isRefreshing: false,
      refreshTimer: null,
      rateError: false // 新增：汇率获取错误标识
    };
  },
  created() {
    this.getcard();
    this.getUsdssList();
    this.baseURL = sessionStorage.getItem('baseURL') || '';
    
    // 初始化时获取汇率
    this.fetchExchangeRate();
    // 启动定时刷新
    this.startRateRefresh();
  },
  beforeDestroy() {
    // 清除定时器
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  },
  methods: {
    changmeyXi(val) {
      this.meyXi = val;
    },
    bindUsdss() {
      if (!this.usdss) {
        this.$parent.showTost(0, '请输入USDT地址');
        return;
      }
      if (!this.meyXi) {
        this.$parent.showTost(0, '请选择钱包协议');
        return;
      }
      if (!this.pay_pass) {
        this.$parent.showTost(0, '请输入支付密码');
        return;
      }
      
      this.$parent.showLoading();
      this.$apiFun
        .post('/api/bindcard', { 
          bank: 'USDT', 
          bank_no: this.usdss, 
          bank_owner: this.meyXi, 
          pay_pass: this.pay_pass 
        })
        .then(res => {
          this.$parent.hideLoading();
          if (res.code !== 200) {
            this.$parent.showTost(0, res.message);
            return;
          }
          
          this.$parent.showTost(1, '添加成功！');
          this.getUsdssList();
          this.openUsdt();
        })
        .catch(() => {
          this.$parent.hideLoading();
        });
    },
    openUsdt() {
      this.showUsdt = !this.showUsdt;
      this.pay_pass = null;
      this.usdss = null;
    },
    changBankId(id) {
      this.bankId = id;
      if (this.type === 0) {
        const selected = this.usdssLis.find(el => el.id === id);
        this.chanmeyXi = selected ? selected.bank_owner : null;
      } else {
        this.chanmeyXi = null;
      }
    },
    withdraw() {
      if (!this.bankId) {
        this.$parent.showTost(0, '您要提现到哪里呢？');
        return;
      }
      if (this.amount < 100) {
        this.$parent.showTost(0, '单笔取款不能低于100元');
        return;
      }
      if (!this.password) {
        this.$parent.showTost(0, '请输入您的支付密码');
        return;
      }
      
      this.$parent.showLoading();
      this.$apiFun
        .post('/api/withdraw', { 
          amount: this.amount, 
          bank: this.bankId, 
          password: this.password 
        })
        .then(res => {
          this.$parent.hideLoading();
          if (res.code !== 200) {
            this.$parent.showTost(0, res.message);
            return;
          }
          
          this.$parent.showTost(1, '提交成功，等待后台审核');
          this.amount = null;
          this.password = null;
          this.bankId = null;
          
          setTimeout(() => {
            this.$router.push({ path: '/assets?type=1' });
          }, 1500);
        })
        .catch(() => {
          this.$parent.hideLoading();
        });
    },
    getUsdssList() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/getcard', { type: 2 })
        .then(res => {
          this.$parent.hideLoading();
          if (res.code === 200) {
            this.usdssLis = res.data;
          } else {
            this.$parent.showTost(0, res.message);
          }
        });
    },
    changType(val) {
      if (this.type === val) return;
      this.type = val;
      this.amount = null;
      this.password = null;
      this.bankId = null;
    },
    getcard() {
      this.$apiFun.post('/api/getcard', { type: 1 })
        .then(res => {
          if (res.code === 200) {
            this.cardLis = res.data;
          } else {
            this.$parent.showTost(0, res.message);
          }
        })
        .catch(() => {
          this.$parent.hideLoading();
        });
    },
    fetchExchangeRate() {
      this.isRefreshing = true;
      this.rateError = false;
      
      // 使用完全免费且无需注册的汇率API
      // 备选API列表：
      // 1. https://open.er-api.com/v6/latest/USD
      // 2. https://api.exchangerate.host/latest?base=USD
      // 3. https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.json
      
      // 这里使用第一个备选API
      const apiUrl = 'https://open.er-api.com/v6/latest/USD';
      
      fetch(apiUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('汇率获取失败');
          }
          return response.json();
        })
        .then(data => {
          this.isRefreshing = false;
          if (data.result === 'success' && data.rates && data.rates.CNY) {
            this.currentRate = data.rates.CNY;
            this.rateError = false;
          } else {
            this.rateError = true;
            console.error('汇率API返回格式错误:', data);
          }
        })
        .catch(error => {
          this.isRefreshing = false;
          this.rateError = true;
          console.error('获取汇率时发生错误:', error);
        });
    },
    
    // 启动定时刷新，延长间隔以减少API压力
    startRateRefresh() {
      // 每3分钟刷新一次汇率（免费API有请求限制）
      this.refreshTimer = setInterval(() => {
        this.fetchExchangeRate();
      }, 180000);
    }
  }
};
</script>

<style lang="scss" scoped>
// 原有样式保持不变
.deposit-container {
  background-color: #ffffff;
  min-height: 100vh;
  padding: 15px;
}

.cardgroup {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 15px;
}

.channels {
  display: flex;
  flex-direction: row;
  height: 50px;
}

.channel {
  flex: 1;
  text-align: center;
  position: relative;
  cursor: pointer;
  padding-top: 12px;
  
  .title {
    color: #666;
    font-size: 16px;
    font-weight: 500;
  }
  
  .border {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: transparent;
  }
}

.channel.active {
  .title {
    color: #333;
  }
  
  .border {
    background-color: #ffc107;
  }
}

.deposit {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 15px;
}

.low-special {
  position: relative;
}

.deposit-title {
  font-size: 15px;
  color: #333;
  margin: 15px 0 8px;
  font-weight: 500;
}

// 修改地址列表为长条样式
.address-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.deposit-bq {
  width: 100%;
  margin-right: 0;
  margin-bottom: 10px;
  cursor: pointer;
}

.deposit-item {
  border-radius: 6px;
  padding: 12px;
  transition: all 0.3s;
  
  &.active {
    background-color: #f9f9f9;
  }
}

.yesBorder {
  border: 1px solid #ffc107;
}

.noBorder {
  border: 1px solid #eee;
}

.deposit-info {
  display: flex;
  align-items: center;
  
  .icon {
    width: 36px;
    height: 36px;
    margin-right: 10px;
  }
  
  span {
    font-size: 14px;
    color: #333;
    line-height: 1.4;
  }
}

.subText {
  font-size: 12px;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
  display: block;
}

.amount-wrap {
  position: relative;
  height: 45px;
  border: 1px solid #eee;
  border-radius: 6px;
  overflow: hidden;
  background-color: #f9f9f9;
}

.amount-input {
  width: 100%;
  height: 100%;
  padding: 0 12px;
  font-size: 16px;
  color: #333;
  border: none;
  outline: none;
  box-sizing: border-box;
  background-color: transparent;
  
  &::placeholder {
    color: #ccc;
  }
}

.amount-unit {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 0 12px;
  line-height: 45px;
  font-size: 14px;
  color: #999;
  background-color: #f0f0f0;
}

.wxsm-tips {
  margin: 15px 0;
  padding: 10px 12px;
  background-color: #f8f8f8;
  border-radius: 6px;
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  
  i {
    width: 16px;
    height: 16px;
    margin-right: 6px;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23666'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z'/%3E%3C/svg%3E") no-repeat center;
    background-size: contain;
  }
  
  span {
    color: #ff8a00;
    text-decoration: underline;
    cursor: pointer;
  }
}

.low-special-btn {
  width: 100%;
  height: 45px;
  line-height: 45px;
  text-align: center;
  background-color: #ffc107;
  color: #fff;
  font-size: 16px;
  border-radius: 6px;
  margin-top: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:active {
    background-color: #e6ac00;
  }
}

/* 弹窗样式 - 修复布局 */
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}

.dialog-cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.dialog-content {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  border-radius: 12px 12px 0 0;
  z-index: 1001;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.side {
  background-color: #fff;
  border-radius: 12px 12px 0 0;
}

.side__header {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  color: #333;
  position: relative;
  border-bottom: 1px solid #eee;
}

.side__close {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23999'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3C/svg%3E") no-repeat center;
  background-size: contain;
}

.side__content {
  padding: 20px 15px;
  max-height: 400px;
  overflow-y: auto;
}

.gold {
  .gold__img {
    width: 100px;
    height: 100px;
    margin: 0 auto 20px;
    display: block;
  }
}

// 修复弹窗表单样式
.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 15px;
  color: #333;
}

.form-control {
  width: 100%;
  height: 45px;
  padding: 0 12px;
  border: 1px solid #eee;
  border-radius: 6px;
  font-size: 15px;
  color: #333;
  outline: none;
  box-sizing: border-box;
  background-color: #f9f9f9;
  
  &::placeholder {
    color: #ccc;
  }
}

.protocol-selector {
  display: flex;
  gap: 10px;
  padding: 5px;
  border: 1px solid #eee;
  border-radius: 6px;
  background-color: #f9f9f9;
}

.protocol-item {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  border-radius: 4px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  background-color: #fff;
  
  &.active {
    background-color: #fff8e1;
    color: #ff8a00;
    border-color: #ffc107;
    box-shadow: 0 0 0 1px #ffc107;
  }
}

.scan__button {
  width: 100%;
  height: 45px;
  background-color: #ffc107;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  margin-top: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:active {
    background-color: #e6ac00;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/withdraw.vue